import { Form, Grid, pn, useElementBreakpoints } from "@compass/core";
import { DatePicker, SubmitButton } from "components";
import { ContributorMatchFilter, ContributorMatchFilterResource } from "generated/openApi";
import produce from "immer";
import "moment-timezone";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";

export const MatchFilter = (props: {
  filter: ContributorMatchFilter;
  setFilter: (value: ContributorMatchFilter) => void;
}) => {
  const { breakpointsRef, xSmallFieldBreakpoints } = useElementBreakpoints();
  const [filter, setFilter] = useState<ContributorMatchFilter>(props.filter);
  const [resource, setResource] = useState<ContributorMatchFilterResource>({});
  const properties = resource.properties || [];

  useEffect(() => {
    ApiService.contributorMatches.getFilterResource().then((response) => {
      setResource(response);
    });
  }, []);

  const dateFromField = () => {
    const propertyName = pn<ContributorMatchFilter>("dateFrom");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <DatePicker
        modelProperty={property}
        value={filter.dateFrom}
        onChange={(value) => {
          setFilter(
            produce((draft) => {
              draft.dateFrom = value;
            })
          );
        }}
        size="small"
      />
    );
  };

  const dateToField = () => {
    const propertyName = pn<ContributorMatchFilter>("dateTo");
    const property = properties.find((x) => x.propertyName === propertyName);

    return (
      <DatePicker
        modelProperty={property}
        value={filter.dateTo}
        onChange={(value) => {
          setFilter(
            produce((draft) => {
              draft.dateTo = value;
            })
          );
        }}
        size="small"
      />
    );
  };

  return (
    <Form style={{ width: "100%" }}>
      <Grid ref={breakpointsRef} container spacing="sm" alignItems="center">
        <Grid item xs={xSmallFieldBreakpoints}>
          {dateFromField()}
        </Grid>
        <Grid item xs={xSmallFieldBreakpoints}>
          {dateToField()}
        </Grid>

        {JSON.stringify(filter) !== JSON.stringify(props.filter) && (
          <Grid item alignItems="center">
            <SubmitButton label="Filter" onClick={() => props.setFilter(filter)} />
          </Grid>
        )}
      </Grid>
    </Form>
  );
};
